function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Checkmark Circle Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.99957895,0.0265263158 C15.5083529,0.0265263158 19.9732632,4.49143657 19.9732632,10.0002105 C19.9732632,15.5082868 15.507998,19.9738947 9.99957895,19.9738947 C4.49185763,19.9738947 0.0258947368,15.5079318 0.0258947368,10.0002105 C0.0258947368,4.49179152 4.49150265,0.0265263158 9.99957895,0.0265263158 Z M9.99957895,1.02652632 C5.04377022,1.02652632 1.02589474,5.04409345 1.02589474,10.0002105 C1.02589474,14.9556471 5.04414237,18.9738947 9.99957895,18.9738947 C14.955696,18.9738947 18.9732632,14.9560193 18.9732632,10.0002105 C18.9732632,5.04372132 14.9560682,1.02652632 9.99957895,1.02652632 Z M14.5636587,6.4887624 C14.7589208,6.68402454 14.7589208,7.00060703 14.5636587,7.19586918 L8.24786918,13.5116587 C8.05260703,13.7069208 7.73602454,13.7069208 7.5407624,13.5116587 L5.43549924,11.4063955 C5.2402371,11.2111333 5.2402371,10.8945509 5.43549924,10.6992887 C5.63076139,10.5040266 5.94734388,10.5040266 6.14260602,10.6992887 L7.89431579,12.4509985 L13.8565519,6.4887624 C14.051814,6.29350025 14.3683965,6.29350025 14.5636587,6.4887624 Z",
  id: "checkmark-circle-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "checkmark-circle-Icon/Global/Validation",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "checkmark-circle-Swatches/Midnight",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "checkmark-circle-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#checkmark-circle-path-1"
})));

var SvgCheckmarkCircle = function SvgCheckmarkCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmarkCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark-circle.ab7a79f4.svg";
export { ForwardRef as ReactComponent };